import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { RoundedTabs } from '@components';
import { STORAGE_KEYS } from '@constants/storage';
import { Event, sendMixpanelEvent } from '@core/analytics/mixpanel';
import { getLocalStorageItem } from '@utils/storage';
import { TabPill } from 'types/tabs';

import { mainTabs } from '../constants/leadDetails';
import { LeadActivityPanelProps } from '../types/leadActivity';
import {
  ActivitiesTab,
  AttachmentsTab,
  FeeCollectionTab,
  NotesTab,
  TimelineTab
} from './lead-activity-panel';

const LeadActivityPanel: React.FC<LeadActivityPanelProps> = ({
  className = '',
  leadId,
  analyticsData
}) => {
  const [selectedTab, setSelectedTab] = useState<TabPill>(mainTabs[0]);
  const { leadDetails } = analyticsData ?? {};
  const { currentOrg } = useSelector((state: any) => state.user);

  const onTabChange = (tab: TabPill) => {
    if (selectedTab.id === tab.id) return;
    if (tab.id === 'activities') {
      sendMixpanelEvent(Event.LEAD_ACTIVITIES_CLICKED, {
        org_id: currentOrg?.id,
        org_name: currentOrg?.name,
        lead_id: leadId,
        lead_name: leadDetails?.leadName,
        lead_phone: leadDetails?.leadPhone
      });
    }
    setSelectedTab(tab);
  };

  useEffect(() => {
    const activityDetails = getLocalStorageItem(STORAGE_KEYS.ACTIVITY_DETAILS);
    if (activityDetails && activityDetails.type) {
      setSelectedTab(mainTabs[0]);
    }
  }, []);

  const renderTabContent = () => {
    switch (selectedTab.id) {
      case 'activities':
        return <ActivitiesTab leadId={leadId} analyticsData={analyticsData} />;
      case 'notes':
        return <NotesTab leadId={leadId} />;
      case 'timeline':
        return <TimelineTab leadId={leadId} />;
      case 'attachments':
        return <AttachmentsTab leadId={leadId} />;
      case 'fee-collection':
        return <FeeCollectionTab leadId={leadId} />;
      default:
        return <ActivitiesTab leadId={leadId} analyticsData={analyticsData} />;
    }
  };

  return (
    <div className={`h-fit w-full rounded-xl ${className}`}>
      <RoundedTabs
        tabs={mainTabs}
        selectedTab={selectedTab}
        onTabSelect={onTabChange}
        borderClassName="!rounded-t-2xl"
        buttonClassName="!rounded-t-2xl !min-w-0 md:!min-w-0"
      />
      <div className="rounded-xl rounded-tl-none border border-grey30 bg-white">
        {renderTabContent()}
      </div>
    </div>
  );
};

export default LeadActivityPanel;
